<template>
  <div class="comp-bench-dialog">
    <el-dialog
      title=""
      :class="noPadding ? 'no-padding' : ''"
      :custom-class="customClass"
      :visible.sync="visible"
      :width="width"
      :close-on-click-modal="closeOnClickModal"
      :close-on-press-escape="closeOnPressEscape"
      :show-close="showClose"
      :before-close="closeClick"
      :destroy-on-close="destroyOnClose"
      :append-to-body="appendToBody"
    >
      <slot></slot>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'BenchDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '30%'
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    closeOnPressEscape: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    customClass: {
      type: String,
      default: 'bench-dialog-class'
    },
    destroyOnClose: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false
    };
  },
  watch: {
    value(nv) {
      this.visible = nv;
    }
  },
  created() {},
  mounted() {},
  methods: {
    closeClick() {
      this.$emit('input', false);
      this.$emit('beforeClose');
    }
  }
};
</script>

<style lang="scss">
.bench-dialog-class,
.bench-dialog--center,
.comp-bench-dialog {
  border-radius: 4px;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__headerbtn {
    top: 15px;
    right: 15px;
    font-weight: bold;
  }
  .el-dialog__headerbtn .el-dialog__close {
    font-weight: bold;
    color: #383874;
  }
}
.bench-dialog-class {
  margin-top: 30vh !important;
}
.bench-dialog-class .el-dialog__close:hover {
  opacity: 0.7;
}
.bench-dialog-tools-class {
  margin-top: 30vh !important;
  background: #f9fafc !important;
}
</style>

<style scoped lang="scss">
/* @import url(); 引入css类 */
</style>
